import React from "react"

import ItemModelV2 from "../../../../../../model2/item2/item-model"
import TasksView_Column from "../../../../../../model2/column/column"
import FieldProto from "../../../../../proto/field-proto"
import {ItemModelV2_CalculatedValues} from "../../../../../../model2/item2/calculated/@type"
import FieldRating_EditableStateful from "../../editable/rating-component"
import FieldRating from "../../../rating"

type Props = {
    style?          : any

    listItem        : ItemModelV2
    column          : TasksView_Column
    field           : FieldProto

    onMouseEnter    : callback
    onMouseLeave    : callback
}

// const debug = "FieldRating_TableCellCalculated_NotHovered"
const debug = false

export default function FieldRating_TableCellCalculated_NotHovered(props: Props) {

    const showSummaryView   = props.listItem.view.isCollapsed
    let notHoveredContent   = null

    const calculatedValues: ItemModelV2_CalculatedValues | undefined = props.listItem.calculated.dataByAggregateFunction[props.field.fieldId as keyof {}]?.[props.column.aggregateFunction!]
    const ownValue = calculatedValues?.own || props.field.getViewValue(props.listItem.item)

    debug && console.log(debug, "renderNotHovered", showSummaryView, calculatedValues)

    if (showSummaryView && !!calculatedValues?.total.value && calculatedValues.total.value != calculatedValues.own) {
        notHoveredContent = (
            <FieldRating_EditableStateful
                field       = {props.field as FieldRating}
                value       = {calculatedValues.total.value}
                disabled    = {true}/>
        )
    } else /*if (ownValue > 0)*/ {
        notHoveredContent = (
            <FieldRating_EditableStateful
                field       = {props.field as FieldRating}
                value       = {ownValue}
                disabled    = {true}/>
        )
    }

    return (
        <div className      = "cell-flex ui5-field-editable size-small ui5-txt-less-important-small"
             style          = {props.style}
             onMouseEnter   = {props.onMouseEnter}
             onMouseLeave   = {props.onMouseLeave}>
            {notHoveredContent}
        </div>
    )
}
